import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import Handler from '../Checkout/Handler';
import Stream from 'flarum/common/utils/Stream';
export default class BountyOption extends Component {
  loading = false;
  oninit(vnode) {
    super.oninit(vnode);
    this.price = this.attrs.price;
    this.product = this.attrs.product;
    this.currency = this.attrs.currency;
    this.for = this.attrs.for;
    this.loading = false;
    this.amount = new Stream(this.attrs.amount === 'other' ? 250 : this.attrs.amount);
  }
  view() {
    return m("div", {
      className: "PriceOption"
    }, m("h2", {
      className: "group"
    }, this.attrs.amount === 'other' ? this.customAmount() : this.currency + this.amount()), m("div", {
      className: "description"
    }, this.description()), m("div", {
      className: "controls"
    }, this.button()));
  }
  customAmount() {
    return m("input", {
      bidi: this.amount,
      size: "10",
      type: "number",
      className: 'FormControl',
      style: "background-color: var(--control-bg)"
    });
  }
  description() {
    return '';
  }
  button() {
    return Button.component({
      icon: 'fas fa-hand-holding-heart',
      className: 'Button hasIcon',
      onclick: this.request.bind(this),
      disabled: this.loading
    }, app.translator.trans('floxum-payments.forum.choose-bounty-amount-modal.checkout-control'));
  }
  request() {
    const handler = new Handler('bounty', {
      discussion: this.for.id(),
      amount: this.amount()
    });
    this.loading = true;
    handler.checkout();
  }
}
flarum.reg.add('floxum-payments', 'forum/Discussion/BountyOption', BountyOption);